/* eslint-disable no-case-declarations */
import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ReportApiService } from '../../../api/bizzmine/report/report-api.service';
import { CollectionForm } from '../../../../models/ts/collection-form.model';
import { AccordionStatusType } from '../../../../models/ts/accordion-status-type.model';
import { NgClass, NgSwitch, NgSwitchCase } from '@angular/common';
import { EditorModule } from '@progress/kendo-angular-editor';
import { FieldFormControlPipe } from '../../../shared/pipes/form/field-form-control/field-form-control.pipe';
import { IconComponent } from '../../../shared/components/ui/icon/icon.component';
import { TranslatePipe } from '../../../shared/pipes/translate/translate.pipe';
import { UserType } from '../../../../models/ts/user-type.model';
import { FormFieldType } from '../../../../models/ts/form-field-type.model';
import { FormMailingListComponent } from '../../../features/bizzmine/form/components/controls/form-mailing-list/form-mailing-list.component';
import { SafePipe } from 'safe-pipe';
import { TableFieldDataType } from '../../../../models/ts/table-field-data-type.model';
import { ProtectedFieldType } from '../../../../models/ts/protected-field-type.model';
import { ReportDto } from '../../../../models/ts/report-dto.model';
import { ThemeDto } from '../../../../models/ts/theme-dto.model';
import { CollectionListApiService } from '../../../api/bizzmine/collection-list/collection-list-api.service';
import { formsActions } from '../../../store/features/forms/forms-actions';
import { Store } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import { StoreCollectionForm } from '../../../store/features/forms/forms-state';
import { GridOptions } from '../../../shared/classes/list/grid-options';
import { BehaviorSubject, take } from 'rxjs';
import { FormControl, FormGroup } from '@angular/forms';
import { CollectionFormService } from '../../../features/bizzmine/form/services/collection-form.service';
import { CollectionFormGroupService } from '../../../features/bizzmine/form/services/collection-form-group.service';
import { FormReportControlComponent } from '../../../shared/components/grid/report-grid/form-report-control/form-report-control.component';
import { CollectionFormField } from 'src/models/ts/collection-form-field.model';
import { CollectionFormFieldValue } from 'src/models/ts/collection-form-field-value.model';
import { GridOptionsDto } from 'src/models/ts/grid-options-dto.model';
import { isEmpty } from 'lodash';
import { PositionType } from 'src/models/ts/position-type.model';
import moment from 'moment';
import { UserSettingsApiService } from 'src/app/api/bizzmine/user-settings/user-settings-api.service';
import { UserSettingsDto } from 'src/models/ts/user-settings-dto.model';
import { ReportNumericControlComponent } from 'src/app/shared/components/forms/controls/report-numeric-control/report-numeric-control.component';
import { ReportInstanceFieldValueHistoryGridComponent } from 'src/app/views/report/report-instance-field-value-history-grid/report-instance-field-value-history-grid.component';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { userSettingsActions } from 'src/app/store/features/user-settings/user-settings-actions';
import {
  CellTemplateDirective,
  ColumnComponent,
  GridComponent,
  NoRecordsTemplateDirective
} from '@progress/kendo-angular-grid';
import { GridColumnType } from 'src/models/ts/grid-column-type.model';
import { CustomWindow } from 'src/app/core/window/custom-window';
import { ThemeService } from 'src/app/core/services/theme/theme.service';
import { ReportTimerangeControlComponent } from 'src/app/shared/components/forms/controls/report-timerange-control/report-timerange-control.component';
// Use a safer cast and const for WINDOW
const WINDOW = window as unknown as CustomWindow;

@Component({
  selector: 'bizz-report-page',
  standalone: true,
  imports: [
    NgClass,
    EditorModule,
    FieldFormControlPipe,
    IconComponent,
    TranslatePipe,
    FormMailingListComponent,
    SafePipe,
    NgSwitch,
    NgSwitchCase,
    FormReportControlComponent,
    IconComponent,
    ReportNumericControlComponent,
    ReportInstanceFieldValueHistoryGridComponent,
    GridComponent,
    ColumnComponent,
    CellTemplateDirective,
    NoRecordsTemplateDirective,
    ReportTimerangeControlComponent
  ],
  templateUrl: './report.component.html',
  styleUrl: './report.component.scss'
})
export class ReportComponent implements OnInit {
  //Querry String Parameters
  public reportId: number;
  public instanceId: number;
  public versionId: number;
  public themeId: number;
  public guidChecksum: string | undefined;
  public userId: number;

  public collectionId: number;
  public listId: number;
  public folderId: number;
  public searchfilterId: number;
  public parentfilterId: number;

  //Report Details
  public reportDetails: ReportDto;
  public theme: ThemeDto | undefined;

  //Form
  public formId: string;
  public collectionForm: CollectionForm;
  public form: FormGroup;
  public storeForm: StoreCollectionForm;
  public lastFieldId: number;
  public gridOptions: Array<{collectionFieldsId: number, gridOptions: GridOptions}> | undefined;

  //List
  public collectionFormList: CollectionForm[];
  public userSettings: UserSettingsDto;

  public backgroundColor: string | undefined;
  public foregroundColor: string | undefined;

  private _div?: HTMLElement;
  private widgetDataLoadedStates: { [fieldId: number]: boolean } = {};
  public allWidgetDataLoaded = new BehaviorSubject<boolean>(false);

  @ViewChild('reportPageNew') public reportPageNew: ElementRef<HTMLElement>;
  public translationService = inject(TranslationService);
  public formUtilitiesService = inject(CollectionFormGroupService);
  public route = inject(ActivatedRoute);
  public reportApiService = inject(ReportApiService);
  public userSettingsApiService = inject(UserSettingsApiService);
  public themeService = inject(ThemeService)

  public constructor(public actions$: Actions, public store$: Store, protected collectionListService: CollectionListApiService) {
    this.route.params.subscribe(params => {
      this.reportId = params['reportId'];
      this.instanceId = params['instanceId'];
      this.versionId = params['versionId'];
      this.themeId = params['themeId'];
      this.guidChecksum = params['guid'];
      this.userId = params['userid'];

      this.collectionId = params['collectionId'];
      this.listId = params['listId'];
      this.folderId = params['folderId'];
      this.searchfilterId = params['searchfilterId'];
      this.parentfilterId = params['parentfilterId'];
    });
  }

  public ngOnInit(): void {
    this.getReportDetails();
    this.userSettingsApiService.getUserSettings().pipe(take(1)).subscribe((userSettings) => {
      this.userSettings = userSettings;
      this.store$.dispatch(userSettingsActions.userSettingsFetched({userSettings}))
      this.translationService.storeTranslations(new Set<number>([this.userSettings.UserLanguagesID, this.userSettings.CompanyLanguagesID]));
      if(this.listId){
        this.getList();
      }else{
        this.getForm();
      }
      // Log when all widget data is loaded
      this.allWidgetDataLoaded.subscribe(allLoaded => {
        if (allLoaded) {
            WINDOW.evoPdfConverter_startConversion();
        }
      });
    });
  }

  public registerWidgetDataLoadedState(fieldId: number, isLoaded: boolean): void {
    this.widgetDataLoadedStates[fieldId] = isLoaded;
    this.checkAllWidgetDataLoaded();
  }

  public checkAllWidgetDataLoaded(): void {
    const allLoaded = Object.values(this.widgetDataLoadedStates).every(loaded => loaded);
    this.allWidgetDataLoaded.next(allLoaded);
  }

  // Checks if last div is rendered on page then starts the pdf conversion
  @ViewChild('contentLoaded')
  public set lastForLoopDiv(div: ElementRef<HTMLElement>) {
    // Only proceed if the div exists and is different from the previously stored div
    if (div && div.nativeElement && this._div !== div.nativeElement) {
      this._div = div.nativeElement;

      // Check if we have any widget data loading states to track
      const widgetDataKeysCount = Object.keys(this.widgetDataLoadedStates).length;

      // Only start conversion immediately if there are no widget data items to wait for
      if (widgetDataKeysCount === 0) {
        WINDOW.evoPdfConverter_startConversion();
      }
      // Otherwise, the conversion will be triggered by allWidgetDataLoaded$ observable
      // which you're already handling in ngOnInit()
    }
  }

  public getSelectedValue(field: CollectionFormField): CollectionFormFieldValue| undefined {
    if (!field.Value) {
      return undefined;
    } else {
      const selectedValue = field.FieldValues.find(val => val.CollectionFieldValuesID == field.Value);
      if (selectedValue !== undefined)
        return selectedValue;
      else throw new Error(`Combobox received invalid value: ${field.Value}. Not present in FieldValues Array.`);
    }
  }

  public setGridOptions (collectionFieldsId:number, gridOptions: GridOptionsDto): void{
    if (gridOptions) {
      const adjustedGridOptions = structuredClone(gridOptions);
      const newGridOptions = new GridOptions(adjustedGridOptions);
      // Form grids are not groupable or sortable
      newGridOptions.groupable = { enabled: false, showFooter: false };
      newGridOptions.sortable = false;
      if(!this.gridOptions){
        this.gridOptions = [];
      }
      this.gridOptions.push({collectionFieldsId: collectionFieldsId, gridOptions: newGridOptions});
    } else {
      throw new Error('GridOptions are required for FormListControlComponent');
    }
  }

  public getFormToStore(form: CollectionForm): void{
    const formWithId = new StoreCollectionForm(form)
    this.store$.dispatch(formsActions.formFetched({
      form: formWithId,
      addToViewStack: true
    }));
    this.storeForm = formWithId;
    this.formId = formWithId.id;
    this.lastFieldId = CollectionFormService.getLastFieldId(form);
    if (this.formData) {
      this.form = this.formUtilitiesService.getFormGroupFromData(this.formData);
    } else {
      console.warn(
        'Could not initialize form group, selector signal from store is undefined'
      );
    }
  }

  public findColumnValue(caption: string, dataItem: {Fields: CollectionFormField[]}): CollectionFormField | undefined {
    const field = dataItem.Fields.find(obj => obj.Caption === caption);

    if (field) {
      // Instead of modifying the original object, create a shallow copy
      const fieldCopy = { ...field };

      if (field.ComponentType === TableFieldDataType.DateTimePicker && field.Value) {
        // Store the formatted date in a new property instead of modifying Value
        fieldCopy.Value = moment(new Date(field.Value),
        this.userSettings.TimezoneName).format(this.userSettings.DateTimeFormatTypeString);
      }

      return fieldCopy;
    }

    return undefined;
  }

  public get formData(): CollectionForm | undefined {
    return this.storeForm?.data;
  }

  public orgchartSelector(field: CollectionFormField): string | undefined {
    return field.OrgChartUnitSelector.find(obj => obj.GroupsID === field.Value)?.Name;
  }

  public getTheme (): ThemeDto | undefined {
    return this.reportDetails.Themes.find(obj => obj.ID === +this.themeId);
  }

  public getReportDetails(): void {
    this.reportApiService.getDetails(this.reportId).subscribe({
      next: response => {
        this.reportDetails = response
        this.theme = this.getTheme();
        if (this.theme) this.themeService.currentTheme$.next(this.theme);
        if (!this.theme) {
          throw new Error(`Reports themeId: ${this.themeId} was not found.`);
        }
      },
    })
  }

  public getForm(): void{
    this.reportApiService.getForm(this.reportId, this.instanceId, this.versionId, this.themeId, this.guidChecksum)
      .subscribe((response: CollectionForm) => {
        response.Accordions.forEach((accordion) => {
          accordion.Rows.forEach((row) => {
            row.Containers.forEach((container) => {
              container.Fields.forEach((field) => {
                //Alter data of formcontrols here if needed
                //remove all tooltips
                field.Hint = '';
                if (field.FormFieldType === FormFieldType.List && field.GridOptions) {
                  this.setGridOptions(field.ViewDataSourcesID, field.GridOptions);
                }

                if (field.FormFieldType === FormFieldType.LinkedCollection && field.GridOptions) {
                  field.FormFieldType = FormFieldType.List;
                  field.GridOptions.dataSource.group = [];
                  this.setGridOptions(field.ViewDataSourcesID, field.GridOptions);
                }

                if (field.FormFieldType === FormFieldType.ReversedUserCollection && field.GridOptions) {
                  field.FormFieldType = FormFieldType.List;
                  field.GridOptions.dataSource.group = [];
                  this.setGridOptions(field.ViewDataSourcesID, field.GridOptions);
                }

                switch (field.ComponentType){
                  case TableFieldDataType.OrganizationChartUnitSelector:
                    field.Value = this.orgchartSelector(field);
                    break;
                  case TableFieldDataType.TimePicker:
                    field.Value = moment(field.Value).format(this.userSettings.TimeFormatTypeString);
                    break;
                  case TableFieldDataType.DatePicker:
                    field.Value = field.Value ? moment(field.Value).format(this.userSettings.DateFormatTypeString.replace('dd', 'DD')) : null;
                    break;
                  case TableFieldDataType.DateTimePicker:
                    field.Value = field.Value ? moment(new Date(field.Value), this.userSettings.TimezoneName).format(this.userSettings.DateTimeFormatTypeString.replace('dd', 'DD')) : null;
                    break;
                  case TableFieldDataType.Combobox:
                  case TableFieldDataType.RadioGroup:
                    if (field.FieldValues && field.DisplayStyleValues !== null && field.DisplayStyleValues.length > 0) {
                      field.FieldValues.forEach(fieldValue => {
                        const coloredValue = field.DisplayStyleValues.find(display => display.CollectionFieldValuesID == fieldValue.CollectionFieldValuesID);
                        if (coloredValue !== undefined) {
                          fieldValue.ForegroundColor = isEmpty(coloredValue.ForegroundColor) ? null : coloredValue.ForegroundColor;
                          fieldValue.BackgroundColor = isEmpty(coloredValue.BackgroundColor) ? null : coloredValue.BackgroundColor;
                        }
                      });
                    }
                    break;
                  default:
                    break;
                }
              });
            });
          });
        });

        this.collectionForm = response;
        this.getFormToStore(response);
      });
  }

  public getList(): void{
    this.reportApiService.getList(this.reportId, this.collectionId, this.listId, this.folderId, this.searchfilterId, this.parentfilterId, this.themeId).subscribe({
      next: response => {
        response.forEach((row) => {
          row.Accordions.forEach((accordion) => {
            accordion.Rows.forEach((row) => {
              row.Containers.forEach((container) => {
                container.Fields.forEach((field) => {
                  //Alter data of formcontrols here if needed
                  //remove all tooltips
                  field.Hint = '';

                  if (field.FormFieldType === FormFieldType.List && field.GridOptions) {
                    this.setGridOptions(field.ViewDataSourcesID, field.GridOptions);
                  }

                  switch (field.ComponentType){
                    case TableFieldDataType.OrganizationChartUnitSelector:
                      field.Value = this.orgchartSelector(field);
                      break;
                    case TableFieldDataType.TimePicker:
                      field.Value = moment(field.Value).format(this.userSettings.TimeFormatTypeString);
                      break;
                    case TableFieldDataType.DatePicker:
                      field.Value = field.Value ? moment(field.Value).format(this.userSettings.DateFormatTypeString.replace('dd', 'DD')) : null;
                      break;
                    case TableFieldDataType.DateTimePicker:
                      field.Value = field.Value ? moment(new Date(field.Value), this.userSettings.TimezoneName).format(this.userSettings.DateTimeFormatTypeString.replace('dd', 'DD')) : null;
                      break;
                    case TableFieldDataType.Combobox:
                    case TableFieldDataType.RadioGroup:
                      if (field.FieldValues && field.DisplayStyleValues !== null && field.DisplayStyleValues.length > 0) {
                        field.FieldValues.forEach(fieldValue => {
                          const coloredValue = field.DisplayStyleValues.find(display => display.CollectionFieldValuesID == fieldValue.CollectionFieldValuesID);
                          if (coloredValue !== undefined) {
                            fieldValue.ForegroundColor = isEmpty(coloredValue.ForegroundColor) ? null : coloredValue.ForegroundColor;
                            fieldValue.BackgroundColor = isEmpty(coloredValue.BackgroundColor) ? null : coloredValue.BackgroundColor;
                          }
                        });
                      }
                      break;
                    default:
                      break;
                  }
                });
              });
            });
          });
        });
        this.collectionFormList = response;
      },
    })
  }

  //Enums
  protected readonly accordionStatusType = AccordionStatusType;
  protected readonly UserType = UserType;
  protected readonly FormFieldType = FormFieldType;
  protected readonly TableFieldDataType = TableFieldDataType;
  protected readonly GridColumnType = GridColumnType;
  protected readonly ProtectedFieldType = ProtectedFieldType;
  protected readonly GridOptions = GridOptions;
  protected readonly FormControl = FormControl;
  protected readonly PositionType = PositionType;

  protected fixEmptyParagraphs(value: string): string {
    return value.replace(/<p(\s[^>]*)?>(\s*)<\/p>/gi, '<p$1><br></p>');
  }

}
